import React, { useState, useEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import qs from 'query-string';
import { changeStartOfWeek } from '../../../helpers/moment';
import AppContext from '../../../store/App/contexts';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';

const TitleFilter = ({
  history,
  location: { search },
  options,
  sites,
  activeSite,
  changeSite,
  setSites,
  setActiveSite,
}) => {
  const params = qs.parse(search);
  const type = localStorage.getItem('type');
  const location = useLocation();
  const { clientFilterHandler, siteFilterHandler, selectedClientID } =
    React.useContext(AppContext);
  const [activeClient, setActiveClient] = useState(selectedClientID);

  useEffect(() => {
    if (selectedClientID != null) {
      setActiveClient(selectedClientID);
    }
  }, [selectedClientID]);

  const handleChangeClient = (e) => {
    const selectedClientId = e.target.value;
    setActiveClient(selectedClientId);
    clientFilterHandler(selectedClientId);
    localStorage.setItem('client', selectedClientId);

    const selectedClient = options?.find((item) => item.id == selectedClientId);
    const sites = selectedClient?.sites || [];
    setSites(sites);

    const defaultSiteId = sites.length > 0 ? sites[0].id : 0;
    setActiveSite(defaultSiteId);
    localStorage.setItem('site', defaultSiteId);

    siteFilterHandler(defaultSiteId);

    if (params.client && params.site) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify({
          ...params,
          client: selectedClientId,
          shift: null,
        }),
      });
    }
  };

  const handleChangeSite = (e) => {
    // if (
    //   location.pathname == '/smart-scheduler' &&
    //   (activeClient == null || activeClient == 0)
    // ) {
    //   ToastUtil.error('You need to select a client first.');
    //   return false;
    // }

    // const regex = /^\/delivery-order\/edit\/\d+$/;
    // if (
    //   regex.test(location.pathname) &&
    //   (activeClient == null || activeClient == 0)
    // ) {
    //   ToastUtil.error('You need to select a client first.');
    //   return false;
    // }

    changeSite(e);
    siteFilterHandler(e.target.value);

    if (params.client && params.site) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify({
          ...params,
          site: e.target.value,
          shift: null,
        }),
      });
    }
  };

  return (
    <div className="d-flex align-items-center pb-2 py-3">
      {type !== 'client' && (
        <div className="d-flex align-items-center ms-3">
          <h6 className="flex-grow-1 mt-2" style={{ color: '#5156BE' }}>
            Client:
          </h6>
          <select
            className="form-select ms-2 adjust-fs rounded-2"
            style={{ width: 200 }}
            value={activeClient || ''}
            onChange={(e) => handleChangeClient(e)}
          >
            {/* {clients && clients.length > 0 && <option value="0">All</option>} */}
            {options &&
              options.length > 0 &&
              options.map((client) => (
                <option key={client.id} value={client.id}>
                  {client.name}
                </option>
              ))}
          </select>
        </div>
      )}

      <div className="d-flex align-items-center ms-3">
        <h6 className="flex-grow-1 mt-2" style={{ color: '#5156BE' }}>
          Site:
        </h6>
        <select
          name=""
          id=""
          className="form-select ms-2 adjust-fs rounded-2"
          style={{ width: 200 }}
          value={
            params.client && params.site
              ? params.site
              : activeSite !== null && activeSite !== undefined
                ? activeSite
                : ''
          }
          onChange={(e) => handleChangeSite(e)}
        >
          {sites && sites.length > 1 && <option value="0">All</option>}
          {sites &&
            sites.length > 0 &&
            sites.map((site) => (
              <option key={site.id} value={site.id}>
                {site.name}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default withRouter(TitleFilter);
